import { Spinner } from '@fluentui/react-components';
import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';

const MergeSuggestionsPage = lazy(() =>
  import('../pages/admin/merge-suggestions/MergeSuggestionsPage').then((m) => ({
    default: m.MergeSuggestionsPage,
  })),
);

export const Route = createFileRoute('/merge-suggestions')({
  component: () => (
    <Suspense fallback={<Spinner style={{ position: 'absolute', top: '25%', left: '50%' }} />}>
      <MergeSuggestionsPage />
    </Suspense>
  ),
});
